import * as React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { type RootState } from "../../../Reducers/ShopfrontReducers";

const connector = connect((state: RootState) => ({
    outlet  : state.location.outlet,
    register: state.location.register,
    global  : state.location.isGlobal,
}));

type PropsFromRedux = ConnectedProps<typeof connector>;

export class CurrentLocation extends React.Component<PropsFromRedux> {
    public render(): React.ReactNode {
        let usingOutlet = false;
        let usingRegister = false;

        if(!this.props.global) {
            if(this.props.outlet && this.props.outlet.name) {
                usingOutlet = true;
            }

            if(this.props.register && this.props.register.name) {
                usingRegister = true;
            }
        }

        const classes = [];

        if(usingOutlet) {
            classes.push("using-outlet");
        } else {
            classes.push("not-using-outlet");
        }

        if(usingRegister) {
            classes.push("using-register");
        } else if(usingOutlet) {
            classes.push("not-using-register");
        }

        let register;

        if(this.props.global) {
            register = "Global";
        } else if(usingRegister) {
            register = this.props.register?.name;
        }

        return (
            <div id="current-location" className={classes.join(" ")}>
                <div id="current-location-outlet">{this.props.outlet && this.props.outlet.name}</div>
                <div id="current-location-register">{register}</div>
            </div>
        );
    }
}

export default connector(CurrentLocation);
